import React from 'react'


const YoutubeCard = ({ item, styles }) => {
  const coloum_value = JSON.parse(item?.coloum_value);
  function getId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
}
const videoId = getId(coloum_value?.coloum_value);

  return (
    <div className='w-full'>
      <iframe title={videoId} src={`https://www.youtube.com/embed/${videoId}`} className="w-full h-[148px] md:h-[388.732px]" frameBorder="0"></iframe>
    </div>
  )
}

export default YoutubeCard